import { takeEvery } from 'redux-saga/effects';
import { SESSION_END } from '../../actions';
import { tokenManager } from '../../../modules/tokens';

function onSessionEnd() {
    tokenManager.clear();
}

export default takeEvery(SESSION_END, onSessionEnd);
